import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { RAIL_OVERLAY_OFFSET_PX } from '@/shared/theme/railSlot'
import type { RailHoverGeometry } from './useRailHoverLabel'
import { StyledHoverBubble } from './styled-components'

export type RailHoverBubbleSide = 'left' | 'right'

interface RailHoverBubbleProps {
  geometry: RailHoverGeometry | null
  label: ReactNode
  side?: RailHoverBubbleSide
}

const RailHoverBubble = ({ geometry, label, side = 'right' }: RailHoverBubbleProps) => {
  if (!geometry) return null

  const { anchor, card } = geometry
  const left = side === 'right' ? card.right + RAIL_OVERLAY_OFFSET_PX : card.left - RAIL_OVERLAY_OFFSET_PX

  return createPortal(
    <StyledHoverBubble $side={side} role='tooltip' style={{ top: anchor.top + anchor.height / 2, left }}>
      {label}
    </StyledHoverBubble>,
    document.body,
  )
}

export default RailHoverBubble
